import React from 'react';

import OemBanner from '../OemBanner/OemBanner';
import MultiHeroBanner from '../MultiHeroBanner/MultiHeroBanner';
import { PageSection } from '../../../../ContentfulTypes';

import {
  Wrapper,
  Container,
} from './styles';

interface Props {
  data: PageSection;
  index: number;
}

const FeatureBanner = ({ data, index }: Props) => {
  if (!data?.combinatorSectionItems?.[0]) return null;
  
  return (
    data?.combinatorSectionItems?.[0]?.__typename === 'ContentfulMultiHeroBanner' ? (
      <Wrapper $index={index}>
        <Container>
          <MultiHeroBanner
            data={data?.combinatorSectionItems[0]}
            event="heroBanner"
            bannerCount={1}
            position={1}
            $index={index}
            className="hero-banner"
          />
        </Container>
      </Wrapper>
    ) : (
      <OemBanner
        data={data}
        event="oem_banner"
        $index={index}
      />
    )
  );
};

export default FeatureBanner;
